"use client";

import { darken, useComputedColorScheme, useMantineTheme } from "@mantine/core";
import WaveBanner from "../../../components/footer/components/WaveBanner";
import PageSection from "../../components/PageSection";
import PrimaryCtaButton from "../../components/PrimaryCtaButton";
import ReviewsSection from "../../components/ReviewsSection";
import SectionHeader from "../../components/SectionHeader";
import TrustedBySchoolsSection from "../../components/TrustedBySchoolsSection";
import WhyWereDifferentSection from "../../components/WhyWereDifferentSection";

export default function ParentLayout() {
  const theme = useMantineTheme();
  const colorScheme = useComputedColorScheme("light");

  return (
    <main>
      {/* 1. Why we're different - framed for parents */}
      <WhyWereDifferentSection
        firstSection={true}
        title="Why Parents Trust Tiber."
        subTitle="Give your child examiner-level IB science support at home. No AI shortcuts—just structured, syllabus-aligned resources used by schools worldwide."
      />
      <WaveBanner
        colors={{
          light: theme.colors.darkblue[9],
          dark: darken(theme.colors.darkblue[9], 0.3),
        }}
        bgColor={
          colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.gray[0]
        }
      />

      {/* 2. Trusted by schools */}
      <TrustedBySchoolsSection
        variant="light"
        title="Used At Leading IB Schools."
        subTitle="Some of the world's leading IB schools use Tiber to outperform their peers. Join them."
      />
      <WaveBanner
        colors={{ light: theme.colors.gray[0], dark: theme.colors.dark[8] }}
        bgColor={
          colorScheme === "dark"
            ? darken(theme.colors.darkblue[9], 0.3)
            : theme.colors.darkblue[9]
        }
      />

      {/* 3. Reviews carousel */}
      <ReviewsSection
        variant="dark"
        title="Driving Results Across The World."
        subTitle="Real stories from IB students and teachers using Tiber to boost their grades."
      />
      <WaveBanner
        colors={{
          light: theme.colors.darkblue[9],
          dark: darken(theme.colors.darkblue[9], 0.3),
        }}
        bgColor={
          colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.gray[0]
        }
      />

      {/* 4. Final CTA – guide parents to pricing */}
      <PageSection variant="light" minHeight={false}>
        <SectionHeader
          title="Flexible Pricing At Every Stage."
          subTitle="Start with the subjects they need today and add or remove subjects later. You're never locked into a rigid bundle."
          align="center"
        />
        <PrimaryCtaButton
          href="/pricing"
          variant={colorScheme === "dark" ? "light" : "dark"}
        >
          Explore Membership Plans
        </PrimaryCtaButton>
      </PageSection>
      <WaveBanner
        colors={{ light: theme.colors.gray[0], dark: theme.colors.dark[8] }}
        bgColor={
          colorScheme === "dark"
            ? theme.colors.dark[9]
            : darken(theme.colors.darkblue[9], 0.2)
        }
      />
    </main>
  );
}
